(function () {
  var supportedLocales = ['fr', 'en', 'tr'];

  function currentLocale() {
    var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    return supportedLocales.indexOf(locale) !== -1 ? locale : null;
  }

  function localePrefix(locale) {
    return locale === 'fr' ? '' : '/' + locale;
  }

  function localizedPath(pathname, prefix) {
    var unprefixedPath = pathname.replace(/^\/(?:en|tr)(?=\/|$)/, '') || '/';
    return prefix + (unprefixedPath.charAt(0) === '/' ? unprefixedPath : '/' + unprefixedPath);
  }

  function normalizeInternalUrl(rawUrl, prefix) {
    if (!rawUrl || rawUrl.charAt(0) === '#' || /^(?:mailto:|tel:|javascript:)/i.test(rawUrl)) return rawUrl;

    var url;
    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return rawUrl;
    }

    if (url.origin !== window.location.origin) return rawUrl;
    if (/^\/(?:admin|checkouts|cdn|\.well-known)(?:\/|$)/.test(url.pathname)) return rawUrl;

    url.pathname = localizedPath(url.pathname, prefix);
    return url.pathname + url.search + url.hash;
  }

  function applyLocaleContext() {
    var locale = currentLocale();
    if (!locale) return;

    var prefix = localePrefix(locale);
    var expectedRoot = prefix + '/';
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var themeRoot = window.routes && window.routes.root_url;
    var mismatch = shopifyRoot !== expectedRoot || themeRoot !== (prefix || '/');

    if (!mismatch) return;

    if (window.Shopify && window.Shopify.routes) window.Shopify.routes.root = expectedRoot;

    if (window.routes) {
      window.routes.root_url = prefix || '/';
      window.routes.cart_url = prefix + '/cart';
      window.routes.cart_add_url = prefix + '/cart/add';
      window.routes.cart_change_url = prefix + '/cart/change';
      window.routes.cart_update_url = prefix + '/cart/update';
    }

    document.querySelectorAll('a[href]').forEach(function (link) {
      var normalizedHref = normalizeInternalUrl(link.getAttribute('href'), prefix);
      if (normalizedHref !== link.getAttribute('href')) link.setAttribute('href', normalizedHref);
    });

    document.querySelectorAll('form.language-form, form.currency-form').forEach(function (form) {
      form.setAttribute('action', prefix + '/localization');
    });
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.language-form .switcher-dropdown .label, .currency-form .switcher-dropdown .label');
    if (label) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var dropdown = label.closest('.switcher-dropdown');
      document.querySelectorAll('.switcher-dropdown.active').forEach(function (openDropdown) {
        if (openDropdown !== dropdown) openDropdown.classList.remove('active');
      });
      dropdown.classList.toggle('active');
      return;
    }

    var option = event.target.closest('[data-language] .language, [data-currency] .currency');
    if (!option) return;

    var form = option.closest('form');
    var inputName = option.classList.contains('language') ? 'locale_code' : 'country_code';
    var input = form && form.querySelector('[name="' + inputName + '"]');
    if (!form || !input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = option.getAttribute('data-value');
    HTMLFormElement.prototype.submit.call(form);
  }, true);

  applyLocaleContext();
  document.addEventListener('shopify:section:load', applyLocaleContext);
})();
